/**
 * Tipos de tipos de ativos
 */
export enum Status {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export interface ClientPlace {
  street?: string;
  number?: string;
  neighborhood?: string;
  cityName?: string;
  stateCode?: string;
}

export interface ClientOutputDTO {
  _id?: string;
  name?: string;
  cpf?: string;
  email?: string;
  whatsapp?: string;
  places?: ClientPlace[];
  createdAt?: string;
  updatedAt?: string;
}

export const StatusLabels: Record<Status, string> = {
  [Status.OPEN]: 'Aberto',
  [Status.CLOSED]: 'Fechado',
};

export interface ClientData {
  phaseForm: string;
  processId: string;
  data: Array<{ field: any; data: any }>;
  status: Status;
}

export interface TokenValidationResponse {
  valid: boolean;
  message?: string;
}

export interface TokenResendResponse {
  success: boolean;
  message?: string;
}

